<script lang="ts">
	import { createEventDispatcher } from 'svelte'
	import { fade } from 'svelte/transition'

	const dispatch = createEventDispatcher()

	export let posTop = -1
	export let posLeft = -1
	export let posRight = -1
	export let opacity = 50
	export let maxW = 'max-w-md'
	export let classPaddingMarging : string | undefined = undefined

	let classPosition = 'popupCenter'
	let varPosTop = '0px'
	let varPosLeft = '0px'
	let varPosRight = '0px'
	let varCssBgOpacity = 0

	// set --tw-bg-opacity because tailwind have a bug in class bg-opacity-???
	if (opacity === 100) varCssBgOpacity = 1
	else if (opacity === 75) varCssBgOpacity = 0.75
	else if (opacity === 50) varCssBgOpacity = 0.5
	else if (opacity === 25) varCssBgOpacity = 0.25

	$: {
		if (posLeft !== -1) classPosition = 'popupTopLeft'
		else if (posRight !== -1) classPosition = 'popupTopRight'

		varPosTop = `${posTop}px`
		varPosLeft = `${posLeft}px`
		varPosRight = `${posRight}px`
	}

	function handleClose() {
		dispatch('close')
	}

	function handleKeydown(event: KeyboardEvent) {
		// https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key
		if (event.key === 'Escape' || event.key === 'Esc') {
			dispatch('close')
		}
	}
	let div: HTMLDivElement
	function handleClickBackground(event: Event) {
		console.log('handleClickBackground')
		if (event.target === div) {
			console.log('dispatch close')
			dispatch('close')
		}
	}
</script>

<svelte:window on:keydown={handleKeydown} />

<!-- blank semi-transparent background -->
<!-- svelte-ignore a11y-click-events-have-key-events -->
<div
	bind:this={div}
	in:fade={{ duration: 400 }}
	on:click={handleClickBackground}
	class="fixed justify-center inset-0 bg-black z-50 flex items-center"
	style="--tw-bg-opacity: {varCssBgOpacity};"
>
	<!-- actual dialog box box -->
	<!-- max-w-md / max-w-2xl -->
	<div
		class="flex flex-col
	            {classPosition} 
				{classPaddingMarging ? classPaddingMarging : 'p-8 m-auto'}
				w-full {maxW}
				border-2 rounded-lg 
				bg-white max-h-full overflow-y-auto"
		style="--pos-top: {varPosTop}; --pos-left: {varPosLeft}; --pos-right: {varPosRight}"
	>
		<!-- x to exit -->
		<button 
			data-test-id="dialog_close"
			class="absolute top-0 right-0 p-2 cursor-pointer text-gray-500 hover:text-gray-700"
			on:click={handleClose} >
			<svg
				class="h-6 w-6 fill-current"
				role="button"
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 20 20"
				><title>Close</title>
				<path
					d="M14.348 14.849a1.2 1.2 0 0 1-1.697 0L10 11.819l-2.651 3.029a1.2 1.2 0 1 1-1.697-1.697l2.758-3.15-2.759-3.152a1.2 1.2 0 1 1 1.697-1.697L10 8.183l2.651-3.031a1.2 1.2 0 1 1 1.697 1.697l-2.758 3.152 2.758 3.15a1.2 1.2 0 0 1 0 1.698z"
				/>
			</svg>
		</button>

		<slot />
	</div>
</div>

<style>
	.popupCenter {
		position: relative;
	}

	.popupTopLeft {
		position: absolute;
		top: var(--pos-top);
		left: var(--pos-left);
	}

	.popupTopRight {
		position: absolute;
		top: var(--pos-top);
		right: var(--pos-right);
	}
</style>
